import { useState } from "react"
import styled from "styled-components"

import {
  Select,
  spacing,
  Text,
  TSelectOption,
} from "@minuthq/meatball-ui-react"

import { ParadiseNativeDateField } from "src/components/Paradise/NativeDateTimeField"
type TDateFilterType = "after" | "before" | "between" | "last_to_relative"

const DATE_FILTER_TYPES: TSelectOption<TDateFilterType>[] = [
  {
    label: "After",
    value: "after",
  },
  {
    label: "Before",
    value: "before",
  },
  {
    label: "Between",
    value: "between",
  },
]
export function ParadiseDateFilter({
  selectedDates,
  onChange,
}: {
  selectedDates: {
    after?: Date
    before?: Date
  }
  onChange: (dates: { after?: Date; before?: Date }) => void
}) {
  const [filterType, setFilterType] = useState<TDateFilterType>(() => {
    if (!selectedDates.after && selectedDates.before) {
      return "before"
    }

    if (selectedDates.after && selectedDates.before) {
      return "between"
    }

    return "after"
  })

  return (
    <Wrapper>
      <Select
        options={DATE_FILTER_TYPES}
        value={filterType}
        onChange={(value) => setFilterType(value as TDateFilterType)}
        size="small"
      />

      <ParadiseDateFilterInput
        filterType={filterType}
        selectedDates={selectedDates}
        onChange={onChange}
      />
    </Wrapper>
  )
}

function ParadiseDateFilterInput({
  filterType,
  selectedDates,
  onChange,
}: {
  filterType: TDateFilterType
  selectedDates: { after?: Date; before?: Date }
  onChange: (dates: { after?: Date; before?: Date }) => void
}) {
  if (filterType === "after") {
    return (
      <ParadiseDateFilterInputAfter
        selectedDates={selectedDates}
        onChange={onChange}
      />
    )
  }

  if (filterType === "before") {
    return (
      <ParadiseDateFilterInputBefore
        selectedDates={selectedDates}
        onChange={onChange}
      />
    )
  }

  if (filterType === "between") {
    return (
      <ParadiseDateFilterInputBetween
        selectedDates={selectedDates}
        onChange={onChange}
      />
    )
  }

  return null
}

function ParadiseDateFilterInputAfter({
  selectedDates,
  onChange,
}: {
  selectedDates: { after?: Date }
  onChange: (dates: { after?: Date }) => void
}) {
  return (
    <ParadiseNativeDateField
      value={selectedDates.after ?? null}
      onChange={(value) => onChange({ after: value ?? undefined })}
      size="small"
      type="date"
    />
  )
}

function ParadiseDateFilterInputBefore({
  selectedDates,
  onChange,
}: {
  selectedDates: { before?: Date }
  onChange: (dates: { before?: Date }) => void
}) {
  return (
    <ParadiseNativeDateField
      value={selectedDates.before ?? null}
      onChange={(value) => onChange({ before: value ?? undefined })}
      size="small"
      type="date"
    />
  )
}

function ParadiseDateFilterInputBetween({
  selectedDates,
  onChange,
}: {
  selectedDates: { after?: Date; before?: Date }
  onChange: (dates: { after?: Date; before?: Date }) => void
}) {
  return (
    <Row>
      <ParadiseNativeDateField
        value={selectedDates.after ?? null}
        onChange={(value) =>
          onChange({
            after: value ?? undefined,
            before: selectedDates.before ?? undefined,
          })
        }
        size="small"
        type="date"
      />

      <Text variant="bodyS">and</Text>

      <ParadiseNativeDateField
        value={selectedDates.before ?? null}
        onChange={(value) =>
          onChange({
            after: selectedDates.after ?? undefined,
            before: value ?? undefined,
          })
        }
        size="small"
        type="date"
      />
    </Row>
  )
}

const Wrapper = styled.div`
  display: grid;
  gap: ${spacing.S};
`

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.S};
`
